import React from "react";
import { podcast } from "../config";

/** 节目封面 + 标题 + 简介（居中版头，管理后台等处使用）。 */
export default function Header() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12,
        margin: "24px 0 32px",
        textAlign: "center",
      }}
    >
      <img
        src={podcast.CoverImageURL}
        alt={`${podcast.Title} 封面`}
        style={{
          width: 128,
          height: 128,
          borderRadius: "var(--radius-lg)",
        }}
      />
      <h1 style={{ fontSize: "var(--text-2xl)" }}>{podcast.Title}</h1>
      <p style={{ color: "var(--text-2)", maxWidth: 560 }}>
        {podcast.Description}
      </p>
    </div>
  );
}
